import { useDebriefDispatch, useDebriefSelector } from 'ff/debrief/hooks';
import { DEBUG_SETTINGS } from 'ff/common/debugMode/debugTypes';
import { setApproach, ApproachDTO } from 'ff/common/debugMode/debugSlice';

const useDebug = () => {
    const debugSlice = useDebriefSelector(s => s.debugSlice);
    const dispatch = useDebriefDispatch();

    const setApproachHandler = (approach: ApproachDTO[] | undefined) => {
        dispatch(setApproach(approach));
    };

    return {
        isDebugMode: debugSlice.isEnabled,
        isDebriefPreciseTimeEnabled:
            debugSlice.isEnabled &&
            debugSlice.features[DEBUG_SETTINGS.DEBRIEF_PRECISE_TIME],
        isDebriefApproachDebugEnabled:
            debugSlice.isEnabled &&
            debugSlice.features[DEBUG_SETTINGS.DEBRIEF_APPROACH_DEBUG],
        approach: debugSlice.approach,
        setApproachHandler: setApproachHandler,
    };
};

export default useDebug;
